export default __webpack_public_path__ + "static/media/edit-icon-link.1759c64e.svg";